import { Suspense, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import AppLoader from "./components/appLoader";
import { useChangeTheme } from "./hooks/useChangeTheme";
import { useAppSelector } from "./hooks/app.hooks";
import { PrivateRouteMain } from "./routes";
import { EmbedEntryScreen, EmbedLayout } from "./embed";
import {
  AuthContainer,
  RegisterContainer,
  privateFeatureRoutes,
} from "./routes/featureRoutes";

function App() {
  const { theme } = useAppSelector((state) => state.app);

  const { chaneTheme } = useChangeTheme();

  useEffect(() => {
    const onVisibilityChange = () => {
      if (document.visibilityState !== "visible") {
        return;
      }
      const path = window.location.pathname;
      // Диалог выбора файла и возврат с камеры дают hidden→visible; на экранах входа/регистрации
      // перезагрузка сбивает форму. На остальных маршрутах сохраняем прежнее поведение.
      if (path === "/login" || path === "/register" || path.startsWith("/embed")) {
        return;
      }
      const isFile = sessionStorage.getItem("isFile");
      console.log('isFile', isFile);
      if (isFile === null) {
        setTimeout(() => {
          window.location.reload();
        }, 800);
      }
    };

    document.addEventListener("visibilitychange", onVisibilityChange);

    const appHeight = () => {
      setTimeout(() => {
        const doc = document.documentElement;
        doc.style.setProperty("--app-height", `${window.innerHeight}px`);
      }, 100);
    };
    window.addEventListener("resize", appHeight);
    appHeight();
    chaneTheme(theme);

    return () => {
      document.removeEventListener("visibilitychange", onVisibilityChange);
      window.removeEventListener("resize", appHeight);
    };
  }, []);

  return (
    <div className={"wrapperView"}>
      <Suspense fallback={<AppLoader isFull={false} />}>
        <Routes>
          <Route path={"/embed"} element={<EmbedLayout />}>
            <Route index element={<EmbedEntryScreen />} />
          </Route>
          <Route path={"/login"} element={<AuthContainer />} />
          <Route path={"/register"} element={<RegisterContainer />} />
          <Route path={"/"} element={<PrivateRouteMain />}>
            {privateFeatureRoutes}
          </Route>
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
